import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import { useMarket } from "#/contexts/MarketContext";
import { useGetDeliveryDelays } from "#/lib/api/delivery-delay";
import { DeliveryDelayPage } from "#/components/pages/delivery-delay/delivery-delay-page";
import type { DeliveryDelayRow } from "#/components/organisms/delivery-delay/types";

const STORAGE_KEY = "deliveryDelay.onlyUnchecked";

export const Route = createFileRoute("/$tenantCode/$market/delivery-delays")({
  beforeLoad: () => ({
    getTitle: () => m["resources.deliveryDelay.name"](),
  }),
  component: DeliveryDelaysRoute,
});

function DeliveryDelaysRoute() {
  const market = useMarket();
  const [onlyUnchecked, setOnlyUnchecked] = useState<boolean>(
    sessionStorage.getItem(STORAGE_KEY) === "true",
  );

  const { data, isLoading } = useGetDeliveryDelays({
    market,
    onlyUnchecked,
  });

  const rows = (data?.member ?? []) as unknown as DeliveryDelayRow[];

  return (
    <DeliveryDelayPage
      data={rows}
      total={rows.length}
      isLoading={isLoading}
      onlyUnchecked={onlyUnchecked}
      onToggleUnchecked={() => {
        const newValue = !onlyUnchecked;
        setOnlyUnchecked(newValue);
        sessionStorage.setItem(STORAGE_KEY, String(newValue));
      }}
    />
  );
}
